module.exports = __webpack_public_path__ + "img/nodata.2585befc.png";